module.exports = __webpack_public_path__ + "static/media/kitchen-solvers-cs2.4fcf48ef.pdf";